<template>
  <div>
    <CatalogList
      v-if="hasCatalogList"
      :id="id"
      :key="id"
      :catalog-list="catalogList"
    />
    <!--todo: refactor empty-container-->
    <div class="empty-container">
      <EmptyList
        v-if="!hasCatalogList && !isLoading"
        text="추천 콘텐츠가 없어요."
      />
    </div>
  </div>
</template>
<script setup>
  import { ref, computed } from 'vue'
  import { getRecommendHomeData } from '@/common/requests/data-fetch/get-recommend-home-data'
  import CatalogList from '@/components/catalog/CatalogList.vue'
  import EmptyList from '@/components/mypooq/EmptyList.vue'

  const catalogData = ref(null)
  const id = ref('')

  const props = defineProps({
    section: {
      type: String, // 'movie' | 'vod'
      default: '',
    },
    contentInfo: {
      type: Object,
      default: () => {},
    },
  })

  const isLoading = ref(false)
  const isVod = computed(() => props.section === 'vod')
  const homeCode = computed(() => (isVod.value ? 'DN1' : 'DN2'))
  const programId = computed(() => props.contentInfo?.programid ?? '')
  const contentId = computed(() => props.contentInfo?.contentid ?? '')
  const movieId = computed(() => props.contentInfo?.movieid ?? '')
  const movieGroupId = computed(() => props.contentInfo?.moviegroupid ?? '')

  const recommendSeriesId = computed(() =>
    isVod.value ? programId.value : movieGroupId.value,
  )
  const recommendContentId = computed(() =>
    isVod.value ? contentId.value : movieId.value,
  )
  const catalogList = computed(() => catalogData.value?.catalogList ?? [])
  const hasCatalogList = computed(
    () => catalogList.value && catalogList.value?.length > 0,
  )

  const init = async () => {
    isLoading.value = true
    const { data } = await getRecommendHomeData({
      homeCode: homeCode.value,
      params: {
        seriesId: recommendSeriesId.value,
        contentId: recommendContentId.value,
      },
    })

    const { catalog } = data?.layout
    catalogData.value = catalog ?? {}
    isLoading.value = false
  }

  init()
</script>
<style setup>
  .empty-container {
    min-width: 1440px;
    margin: 0 100px;
  }
</style>
